import { Spin } from "antd";
import { Card, Col } from "reactstrap";
import StudentActivitiesCardHeader from "./StudentActivitiesCardHeader";
import StudentActivitiesCardBody from "./StudentActivitiesCardBody";

const StudentActivities = ({ studentActivities, loading }) => {
  return (
    <Col md="6" xl="6" className="box-col-33">
      <Card className="relative">
        {loading && <div className={`charts-initial-loading`}><Spin /></div>}
        <StudentActivitiesCardHeader />
        <StudentActivitiesCardBody studentActivities={studentActivities} />
      </Card>
    </Col>
  );
};

export default StudentActivities;